"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.group.demonstrations.fin.dre", {
            url: "/DRE/:date/:view",
            views: {
                "financialDemonstrationsView@nucont.accounting.group.demonstrations.fin": {
                    component: "financialDreComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                demonstration: { value: "DRE", dynamic: false },
                date: { value: null, dynamic: true },
                view: { value: "mensal", dynamic: true },
                stateIndentifier: { value: "dre" }
            },
            bodyClass: "dre-module"
        })
        .state("nucont.accounting.group.demonstrations.fin.dre.showtime", {
            url: "/showtime",
            bodyClass: "dre-module"
        })
        .state(
            "nucont.accounting.group.demonstrations.fin.dre.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.fin.dre": {
                        component: "indicatorDescriptionComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.fin.dre.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.fin.dre": {
                        component: "indicatorCommentsComponent",
                        bindings: { companyData: "groupData" }
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.fin.dre.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.fin.dre": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state("nucont.accounting.group.demonstrations.fin.dre.comparation", {
            url:
                "/comparacao?month&comparationView&comparationDate&analysisHorizontal&analysisVertical",
            views: {
                "financialDemonstrationsView@nucont.accounting.group.demonstrations.fin": {
                    component: "financialDREComparation",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                comparationView: { value: null, dynamic: true },
                comparationDate: { value: null, dynamic: true },
                analysisHorizontal: { value: null, dynamic: true },
                analysisVertical: { value: null, dynamic: true },
                month: { value: null, dynamic: true },
                stateIndentifier: { value: "dre.comparation" }
            },
            bodyClass: "dre-module"
        })
        .state(
            "nucont.accounting.group.demonstrations.fin.dre.comparation.showtime",
            {
                url: "/showtime",
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.fin.dre.comparation.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.fin.dre.comparation": {
                        component: "indicatorDescriptionComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.fin.dre.comparation.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.fin.dre.comparation": {
                        component: "indicatorCommentsComponent",
                        bindings: { companyData: "groupData" }
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.fin.dre.comparation.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.fin.dre.comparation": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        );
}
